import axios from "axios";
var url = '';
if(window.location.origin == 'https://orgp.zens10.com'){
  url = 'https://apps.zens10.com/'
} else if(window.location.origin == 'https://org.zens10.com'){
  url = 'https://app.zens10.com/'
} else {
  url = 'https://lite.zens10.com/'
};
const service  = axios.create({
  baseURL:url,
  timeout:60000
});

export default service 


// WEBPACK FOOTER //
// ./src/assets/js/request.js